import { render, staticRenderFns } from "./DlvD_Total.vue?vue&type=template&id=69ad6a04"
import script from "./DlvD_Total.vue?vue&type=script&lang=js"
export * from "./DlvD_Total.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports